import { createAction, props } from '@ngrx/store';
import { LiveKitModels } from '@models/livekit.model';
import { PlaybackMonitoringModels } from '@models/playback-monitoring.models';
export const resetToInitialState = createAction('[PLAYBACK-MONITORING] Reset to Initial state');

export const getPlaybackMonitoring = createAction('[PLAYBACK-MONITORING] Get Playback Monitoring');
export const getPlaybackMonitoringSuccess = createAction('[PLAYBACK-MONITORING] Get Playback Monitoring success', props<{
  playbacks: PlaybackMonitoringModels.PlaybackListItem[],
  playbackDevices: PlaybackMonitoringModels.PlaybackDevice[]
}>());

export const setInitialLoader = createAction(
  '[PLAYBACK-MONITORING] Set initial loader',
  props<{
    loading: boolean
  }>());

export const deploy = createAction(
  '[PLAYBACK-MONITORING] Deploy',
  props<{
    body: PlaybackMonitoringModels.DeployBody,
  }>());
export const setIsDeploying = createAction(
  '[PLAYBACK-MONITORING] Set Is Deploying',
  props<{
    isDeploying: boolean
  }>());
export const deploySuccess = createAction(
  '[PLAYBACK-MONITORING] Deploy Success',
);
export const deployFail = createAction(
  '[PLAYBACK-MONITORING] Deploy Fail',
);

export const shutdown = createAction(
  '[PLAYBACK-MONITORING] shutdown',
  props<{
    vmId: string,
    cordon: boolean
  }>());
export const shutdownSuccess = createAction(
  '[PLAYBACK-MONITORING] shutdown Success',
);
export const shutdownFail = createAction(
  '[PLAYBACK-MONITORING] shutdown Fail',
);

export const stopShutdownLoading = createAction(
  '[PLAYBACK-MONITORING] stop shutdown Loading',
  props<{
    vmId: string
  }>());

export const getListForCleaning = createAction(
  '[PLAYBACK-MONITORING] Get List For Cleaning');

export const getListForCleaningSuccess = createAction(
  '[PLAYBACK-MONITORING] Get List For Cleaning Success',
  props<{
    list: PlaybackMonitoringModels.PlaybackListItem[],
  }>());

export const getListForCleaningFail = createAction(
  '[PLAYBACK-MONITORING] Get List For Cleaning Fail');

export const startCleanPlaybackList = createAction(
  '[PLAYBACK-MONITORING] Start clean playback list');

export const cleanPlaybackListSuccess = createAction(
  '[PLAYBACK-MONITORING] clean playback list success');

export const cleanPlaybackListFail = createAction(
  '[PLAYBACK-MONITORING] clean playback list fail');

export const skip = createAction(
  '[PLAYBACK-MONITORING] skip playback',
  props<{
    skip: boolean,
    vmId: string
  }>());

export const skipSuccess = createAction(
  '[PLAYBACK-MONITORING] skip playback success',
  props<{
    skip: boolean,
    vmId: string
  }>());

export const skipFail = createAction(
  '[PLAYBACK-MONITORING] skip playback fail',
  props<{
    skip: boolean,
    vmId: string
  }>());